import * as React from 'react';
import {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import Formatter from '../../../util/formatter';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../hooks/useOpenState';
import {ColumnTypes} from './../hl7/hl7_messages_comp';
import ColumnsManager, {getColumns} from './../hl7/columns_manager';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../store/reducers/preferences';
import _ from 'lodash';
import UserLoginAuditTable from './user_login_audit_table';


const UserLoginAudit = forwardRef((props, ref) => {

    const {t} = useTranslation();
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [selectedRow, setSelectedRow] = React.useState(null);

    const [detailsModalIsVisible, setDetailsModalIsVisible] = useState(false);
    const [detailsMessage, setDetailsMessage] = useState(null);

    const openMessageDetails = (message) => {
        setDetailsMessage(message)
        setDetailsModalIsVisible(true);
    }
    const tableRef = React.useRef(null);
    useImperativeHandle(ref, () => ({
        exportCsv: () => {
            return tableRef.current.exportCsv();
        },
    }));
    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])

    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.inMessageColumnOrder));
    },[agylePreference, props.timeInUtc]);

    const openJsonModal = (row) => {
        if(row.message) {
            setSelectedRow(row)
            openModal();
        } else {

        }
    }

    const columnsInit = [
        {
            name: 'userName',
            order: 1,
            value: 'userName',
            type: ColumnTypes.TEXT,
            description: t('Username'),
            minWidth: 150,
            maxWidth: 275,
        },
        {
            name: 'lastLoginDate',
            order: 1,
            value: 'lastLoginDate',
            type: ColumnTypes.TEXT,
            description: 'Last Login',
            minWidth: 175,
            maxWidth: 175,
            sort: true,
            format: (value) => {
                return props.timeInUtc? Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss",""): Formatter.LocalFormatData(value,"YYYY-MM-DD HH:mm:ss");
            }
        },
        {
            name: 'daysFromLastLogin',
            order: 1,
            value: 'daysFromLastLogin',
            type: ColumnTypes.TEXT,
            description: 'No. of days from Last Login',
            minWidth: 100,
            maxWidth: 175,
        }

    ];


    const handleCloseMessageDetails = () =>{
        setDetailsModalIsVisible(false);
    }


    const getMessage = (row) => {
        return row.message
    }

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };


    const [openConfig, setOpenConfig] = React.useState(false);

    return (<div>
        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"Users Login Audit Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <UserLoginAuditTable ref={tableRef} table = {"usersLoginAudit"} openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"TODODocReports"} columns={sortColumn()} messagePath={getMessage} {...props}/>
    </div>);
})

export default UserLoginAudit;